import { useContext } from 'react'
import { ActSnackbar } from 'genesis-suite/components'
import { CloudContext } from '../contexts/CloudContext'
import { AuthContext } from '../contexts/AuthContext'
import { deActAsFun } from './actions'

export default function ActAsSnackbar() {
    const { selectedCloud, setActAsCloud } = useContext(CloudContext)
    const { setOUser, actAs, setActAs } = useContext(AuthContext)

    const removeUser = () => {
        const params = {
            modelName: selectedCloud,
        }
        setActAsCloud(null)
        deActAsFun(params, setActAs, setOUser)
    }

    return (
        <>
            <ActSnackbar actAsUser={actAs} removeUser={removeUser} />
        </>
    )
}
